import React, { useRef, useState } from 'react';
import commonData from '../data/common.json';

function Chatbot() {
  const messagesEndRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSendMessage = () => {
    if (inputValue.trim() !== '') {
      setMessages([...messages, { text: inputValue, sender: 'user' }]);
      processUserInput(inputValue);
      setInputValue('');
    }
  };

  const processUserInput = (userInput) => {
    const casualRes = commonData.casual.find(
      ({ pattern }) =>
        pattern.includes(userInput) ||
        pattern.find((q) =>
          q
            .toLowerCase()
            .includes(userInput.replace(/[!@#$%^&*]/g, '').toLowerCase())
        )
    )?.response;

    const botResponse = ` ${userInput}`;
    setTimeout(() => {
      setMessages([
        ...messages,
        { text: botResponse, sender: 'user' },
        { text: casualRes || "I didn't get it, ", sender: 'bot' }
      ]);
      speak(casualRes || "I didn't get it, ");
    }, 500);
  };

  const speak = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    speechSynthesis.speak(utterance);
  };

  return (
    <div className='chatbot'>
      <div ref={messagesEndRef} className='chatbot-messages'>
        {messages.map((message, index) => (
          <div key={index} className='message'>
            <span className={message.sender}>{message.text}</span>
          </div>
        ))}
      </div>
      <div className='chatbot-input'>
        <input
          type='text'
          className='chat-inp'
          placeholder='Type your message...'
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={({ key }) => key === 'Enter' && handleSendMessage()}
        />
        <button className='chat-btn' onClick={handleSendMessage}>
          ⏩
        </button>
      </div>
    </div>
  );
}

export default Chatbot;
